import { FormattedMessage, defineMessages } from "react-intl";

import { Text } from "@/components/atoms/Text";

import { IEventFaqDefinition } from "../../../types/local-types";

export const EVENT_ACTIVITIES_FORM = "EVENT_ACTIVITIES_FORM";
export const ALCOHOLIC_BEVERAGE_FORM = "ALCOHOLIC_BEVERAGE_FORM";
export const EVENT_RULES_FORM = "EVENT_RULES_FORM";
export const FURNITURE_FORM = "FURNITURE_FORM";
export const AV_MUSIC_FORM = "AV_MUSIC_FORM";
export const FOOD_BEVERAGE_FORM = "FOOD_BEVERAGE_FORM";
export const RESTROOM_FORM = "RESTROOM_FORM";

export const EVENT_FAQ_CONST = {
  FOOD_BEVERAGE_RULES: "food_beverage_rules",
  FOOD_PREP_RULES: "food_prep_rules",
  FULL_KITCHEN: "full_kitchen",
  COMMERCIAL_KITCHEN: "commercial_kitchen",
  KITCHENETTE: "kitchenette",
  PREP_AREA: "prep_area",
  PLACE_SETTINGS: "place_settings",
  SERVING_UTENSILS: "serving_utensils",
  CUPS_GLASSES: "cups_glasses",
  WINE_GLASSES: "wine_glasses",
  BRING_ALCOHOL: "bring_alcohol",
  BRING_ALCOHOL_RULES: "bring_alcohol_rules",
  ALCOHOL_MUST_BE_SERVED_BY_LICENSED_VENDOR:
    "alcohol_must_be_served_by_licensed_vendor",
  CAN_PURCHASE_ALCOHOL_AT_FULL_SERVICE_BAR:
    "can_purchase_alcohol_at_full_service_bar",
  CAN_PURCHASE_BEER_WINE_AT_BAR: "can_purchase_beer_wine_at_bar",
  OTHER_ALCOHOL_CONSUMPTION_RULES: "other_alcohol_consumption_rules",
  TABLES: "tables",
  CHAIRS: "chairs",
  SOFT_SEATING: "soft_seating",
  STANDARD_RESTROOMS: "standard_restrooms",
  ADA_RESTROOMS: "ada_restrooms",
  NURSING_ROOMS: "nursing_rooms",
  MICROPHONES: "microphones",
  PROJECTOR: "projector",
  SPEAKERS: "speakers",
  TELEVISION: "television",
  MISC_AV_EQUIPMENT: "misc_av_equipment",
  IS_DJ_ALLOWED: "is_dj_allowed",
  IS_LIVE_MUSIC_ALLOWED: "is_live_music_allowed",
  IS_AMPLIFIED_MUSIC_ALLOWED: "is_amplified_music_allowed",
  IS_CONNECTED_AMPLIFIED_MUSIC_ALLOWED: "is_connected_amplified_music_allowed",
  ARCADE_GAMES: "arcade_games",
  DARTS: "darts",
  KARAOKE: "karaoke",
  PING_PONG_TABLE: "ping_pong_table",
  POOL_TABLE: "pool_table",
  SHUFFLEBOARD: "shuffleboard",
  MISC_ACTIVITIES: "misc_activities",
  IS_21ST_BDAY_PROHIBITED: "is_21st_bday_prohibited",
  IS_AFTER_PARTY_PROHIBITED: "is_after_party_prohibited",
  IS_ALBUM_RELEASE_PARTY_PROHIBITED: "is_album_release_party_prohibited",
  IS_BACHELOR_PARTY_PROHIBITED: "is_bachelor_party_prohibited",
  IS_CONCERT_PROHIBITED: "is_concert_prohibited",
  IS_FESTIVAL_HOLIDAY_PARTY_PROHIBITED: "is_festival_holiday_party_prohibited",
  IS_INFLUENCER_EVENT_PROHIBITED: "is_influencer_event_prohibited",
  IS_KIDS_PARTY_PROHIBITED: "is_kids_party_prohibited",
  IS_SPORTS_VIEWING_PARTY_PROHIBITED: "is_sports_viewing_party_prohibited",
  IS_PARTY_PROHIBITED: "is_party_prohibited",
  IS_WEDDING_PROHIBITED: "is_wedding_prohibited",
  OTHER_PROHIBITED_ACTIVITY: "other_prohibited_activity",
  HAS_QUIET_HOURS: "has_quiet_hours",
  LOUD_MUSIC_ENDS_BY: "loud_music_ends_by",
  HAS_FLEXIBLE_HOURS: "has_flexible_hours",
  IS_GLITTER_ALLOWED: "is_glitter_allowed",
  IS_HIRED_SECURITY_REQUIRED: "is_hired_security_required",
  ARE_OPEN_FLAMES_ALLOWED: "are_open_flames_allowed",
  ARE_PETS_ALLOWED: "are_pets_allowed",
  IS_SMOKING_ALLOWED: "is_smoking_allowed",
  ARE_TICKETED_EVENTS_ALLOWED: "are_ticketed_events_allowed",
  OTHER_EVENT_RULES: "other_event_rules",
};

export const EVENT_FAQ_ANSWERS_CONST = {
  OUTSIDE_FOOD_BEVERAGE_ALLOWED: "outside_food_beverage_allowed",
  ON_SITE_FOOD_BEVERAGE: "on_site_food_beverage",
  LICENSED_FOOD_BEVERAGE: "licensed_food_beverage",
  OTHER_FOOD_AND_BEVERAGE_RULES: "other_food_and_beverage_rules",
  NO_OUTSIDE_FOOD_BEVERAGE: "no_outside_food_beverage",
  COOKING_AND_PREP_ALLOWED: "cooking_and_prep_allowed",
  ONLY_FOOD_PREP: "only_food_prep",
  NO_COOKING_ALLOWED: "no_cooking_allowed",
  OTHER_FOOD_PREP_RULES: "other_food_prep_rules",
  BRING_ALCOHOL_ALLOWED: "bring_alcohol_allowed",
  BRING_ALCOHOL_NOT_ALLOWED: "bring_alcohol_not_allowed",
  NO_ALCOHOL_ALLOWED: "no_alcohol_allowed",
  ANY_ALCOHOL: "any_alcohol",
  LIQUOR_NOT_ALLOWED: "liquor_not_allowed",
  LICENSED_LIQUOR: "licensed_liquor",
  HOURS_ADJUSTED_UPON_REQUEST: "hours_adjusted_upon_request",
  HAS_NO_FLEXIBLE_HOURS: "has_no_flexible_hours",
};

export const AMENITIES_LIST = new Set([
  EVENT_FAQ_CONST.FULL_KITCHEN,
  EVENT_FAQ_CONST.COMMERCIAL_KITCHEN,
  EVENT_FAQ_CONST.KITCHENETTE,
  EVENT_FAQ_CONST.PREP_AREA,
  EVENT_FAQ_CONST.PLACE_SETTINGS,
  EVENT_FAQ_CONST.SERVING_UTENSILS,
  EVENT_FAQ_CONST.CUPS_GLASSES,
  EVENT_FAQ_CONST.WINE_GLASSES,
  EVENT_FAQ_CONST.TABLES,
  EVENT_FAQ_CONST.CHAIRS,
  EVENT_FAQ_CONST.SOFT_SEATING,
  EVENT_FAQ_CONST.STANDARD_RESTROOMS,
  EVENT_FAQ_CONST.ADA_RESTROOMS,
  EVENT_FAQ_CONST.NURSING_ROOMS,
  EVENT_FAQ_CONST.MICROPHONES,
  EVENT_FAQ_CONST.PROJECTOR,
  EVENT_FAQ_CONST.SPEAKERS,
  EVENT_FAQ_CONST.TELEVISION,
  EVENT_FAQ_CONST.MISC_AV_EQUIPMENT,
  EVENT_FAQ_CONST.ARCADE_GAMES,
  EVENT_FAQ_CONST.DARTS,
  EVENT_FAQ_CONST.KARAOKE,
  EVENT_FAQ_CONST.PING_PONG_TABLE,
  EVENT_FAQ_CONST.POOL_TABLE,
  EVENT_FAQ_CONST.SHUFFLEBOARD,
  EVENT_FAQ_CONST.MISC_ACTIVITIES,
]);

export const FOOD_BEVERAGE_PROPS = [
  EVENT_FAQ_CONST.FOOD_BEVERAGE_RULES,
  EVENT_FAQ_CONST.FOOD_PREP_RULES,
  EVENT_FAQ_CONST.FULL_KITCHEN,
  EVENT_FAQ_CONST.COMMERCIAL_KITCHEN,
  EVENT_FAQ_CONST.KITCHENETTE,
  EVENT_FAQ_CONST.PREP_AREA,
  EVENT_FAQ_CONST.PLACE_SETTINGS,
  EVENT_FAQ_CONST.SERVING_UTENSILS,
  EVENT_FAQ_CONST.CUPS_GLASSES,
  EVENT_FAQ_CONST.WINE_GLASSES,
];

export const ALCOHOL_PROPS = [
  EVENT_FAQ_CONST.BRING_ALCOHOL,
  EVENT_FAQ_CONST.BRING_ALCOHOL_RULES,
  EVENT_FAQ_CONST.ALCOHOL_MUST_BE_SERVED_BY_LICENSED_VENDOR,
  EVENT_FAQ_CONST.CAN_PURCHASE_ALCOHOL_AT_FULL_SERVICE_BAR,
  EVENT_FAQ_CONST.CAN_PURCHASE_BEER_WINE_AT_BAR,
  EVENT_FAQ_CONST.OTHER_ALCOHOL_CONSUMPTION_RULES,
];

export const FURNITURE_PROPS = [
  EVENT_FAQ_CONST.TABLES,
  EVENT_FAQ_CONST.CHAIRS,
  EVENT_FAQ_CONST.SOFT_SEATING,
];

export const RESTROOM_PROPS = [
  EVENT_FAQ_CONST.STANDARD_RESTROOMS,
  EVENT_FAQ_CONST.ADA_RESTROOMS,
  EVENT_FAQ_CONST.NURSING_ROOMS,
];

export const AV_MUSIC_PROPS = [
  EVENT_FAQ_CONST.MICROPHONES,
  EVENT_FAQ_CONST.PROJECTOR,
  EVENT_FAQ_CONST.SPEAKERS,
  EVENT_FAQ_CONST.TELEVISION,
  EVENT_FAQ_CONST.MISC_AV_EQUIPMENT,
  EVENT_FAQ_CONST.IS_DJ_ALLOWED,
  EVENT_FAQ_CONST.IS_LIVE_MUSIC_ALLOWED,
  EVENT_FAQ_CONST.IS_AMPLIFIED_MUSIC_ALLOWED,
  EVENT_FAQ_CONST.IS_CONNECTED_AMPLIFIED_MUSIC_ALLOWED,
];

export const EVENT_ACTIVITIES_PROPS = [
  EVENT_FAQ_CONST.ARCADE_GAMES,
  EVENT_FAQ_CONST.DARTS,
  EVENT_FAQ_CONST.KARAOKE,
  EVENT_FAQ_CONST.PING_PONG_TABLE,
  EVENT_FAQ_CONST.POOL_TABLE,
  EVENT_FAQ_CONST.SHUFFLEBOARD,
  EVENT_FAQ_CONST.MISC_ACTIVITIES,
  EVENT_FAQ_CONST.IS_21ST_BDAY_PROHIBITED,
  EVENT_FAQ_CONST.IS_AFTER_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_ALBUM_RELEASE_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_BACHELOR_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_CONCERT_PROHIBITED,
  EVENT_FAQ_CONST.IS_FESTIVAL_HOLIDAY_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_INFLUENCER_EVENT_PROHIBITED,
  EVENT_FAQ_CONST.IS_KIDS_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_SPORTS_VIEWING_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_WEDDING_PROHIBITED,
  EVENT_FAQ_CONST.OTHER_PROHIBITED_ACTIVITY,
];

export const EVENT_RULES_PROPS = [
  EVENT_FAQ_CONST.HAS_QUIET_HOURS,
  EVENT_FAQ_CONST.LOUD_MUSIC_ENDS_BY,
  EVENT_FAQ_CONST.HAS_FLEXIBLE_HOURS,
  EVENT_FAQ_CONST.IS_GLITTER_ALLOWED,
  EVENT_FAQ_CONST.IS_HIRED_SECURITY_REQUIRED,
  EVENT_FAQ_CONST.ARE_OPEN_FLAMES_ALLOWED,
  EVENT_FAQ_CONST.ARE_PETS_ALLOWED,
  EVENT_FAQ_CONST.IS_SMOKING_ALLOWED,
  EVENT_FAQ_CONST.ARE_TICKETED_EVENTS_ALLOWED,
  EVENT_FAQ_CONST.OTHER_EVENT_RULES,
];

const miscEventFaqDefinitions = defineMessages({
  eventFaqTocHeader: {
    id: "shared.faq_form.eventFaqTocHeader",
    defaultMessage: "Set up your FAQ",
  },
  eventFaqTocSubheader: {
    id: "shared.faq_form.eventFaqTocSubheader",
    defaultMessage:
      "Answer frequently asked questions and rules about event bookings",
  },
  eventFaqNux: {
    id: "shared.faq_form.eventFaqNux",
    defaultMessage: "Set up your FAQ",
  },
  next: {
    id: "shared.faq_form.next_button_text",
    defaultMessage: "Next",
  },
  exit: {
    id: "shared.faq_form.exit_button_text",
    defaultMessage: "Save and exit",
  },
  place_settings_subheader: {
    id: "shared.faq_form.place_settings_subheader",
    defaultMessage: "Plates, utensils, etc.",
  },
  serving_utensils_subheader: {
    id: "shared.faq_form.serving_utensils_subheader",
    defaultMessage: "Serving spoons, tongs, etc..",
  },
  text_area_placeholder: {
    id: "shared.faq_form.text_area_description",
    defaultMessage: "Add a short description...",
  },
  other_food_rules_placeholder: {
    id: "shared.faq_form.other_food_rules_placeholder",
    defaultMessage:
      "Please describe your rules regarding food and non-alcoholic beverages...",
  },
  other_food_prep_rules_placeholder: {
    id: "shared.faq_form.other_food_prep_rules_placeholder",
    defaultMessage:
      "Please describe your rules regarding cooking and food preparation...",
  },
  place_setting_tooltip: {
    id: "shared.faq_form.place_setting_tooltip",
    defaultMessage:
      "Maximum amount of guests the available place settings can accommodate.",
  },
  cups_tooltip: {
    id: "shared.faq_form.cups_tooltip.cups_tooltip",
    defaultMessage: "Amount of cups available to guests during their booking.",
  },
  wine_glasses_tooltip: {
    id: "shared.faq_form.wine_glasses_tooltip",
    defaultMessage:
      "Amount of wine glasses available to guests during their booking.",
  },
  alcohol_consumption_placeholder: {
    id: "shared.faq_form.alcohol_consumption_placeholder",
    defaultMessage:
      "Please describe your rules regarding alcohol consumption...",
  },
  tables_tooltip: {
    id: "shared.faq_form.tables_tooltip",
    defaultMessage:
      "Total tables. Describe types of tables and seating capacity in the description below.",
  },
  chairs_tooltip: {
    id: "shared.faq_form.chairs_tooltip",
    defaultMessage:
      "Total chairs. Describe styles of chairs in the description below.",
  },
  soft_seating_tooltip: {
    id: "shared.faq_form.soft_seating_tooltip",
    defaultMessage:
      "Maximum seating capacity for your soft seating (e.g. a sofa that seats 3, plus 2 lounge chairs, would be a seating capacity of 5). ",
  },
  restroom_tooltip: {
    id: "shared.faq_form.restroom_tooltip",
    defaultMessage:
      "Amount of restrooms (including stalls) available for guests during their booking.",
  },
  other_av_equipment_placeholder: {
    id: "shared.faq_form.other_av_equipment",
    defaultMessage: "Please describe any other AV equipment...",
  },
  other_activities_placeholder: {
    id: "shared.faq_form.other_activities_placeholder",
    defaultMessage:
      "Please describe any other activities available in your space...",
  },
  other_prohibited_activities_placeholder: {
    id: "shared.faq_form.other_prohibited_activities_placeholder",
    defaultMessage:
      "Please describe your any other activities you’d prefer to not host...",
  },
  other_prohibited_activities_tips: {
    id: "shared.faq_form.other_prohibited_activities_tips",
    defaultMessage:
      "We'll show these as activities you'd prefer to not host. Guests can still book them, so monitor and choose to accept or decline bookings.",
  },
  other_prohibited_activities_tips_guest: {
    id: "shared.faq_form.other_prohibited_activities_tips_guest",
    defaultMessage:
      "Hosts may not accept your booking if you choose to book for these activities.",
  },
  other_event_rules_placeholder: {
    id: "shared.faq_form.other_event_rules_placeholder",
    defaultMessage:
      "Please describe any other rules regarding event bookings...",
  },
  food_rules: {
    id: "shared.event_faq.section.food_rules",
    defaultMessage: "Rules for food and non-alcoholic beverages",
  },
  food_prep_rules: {
    id: "shared.event_faq.section.food_prep_rules",
    defaultMessage: "Rules for cooking and food preparation",
  },
  quiet_hours_header: {
    id: "shared.event_rules_form.quiet_hours_header",
    defaultMessage: "Does your space have quiet hours?*",
  },
  flexible_hours: {
    id: "shared.event_rules_form.flexible_hours",
    defaultMessage: "Are your bookable hours flexible? ",
  },
  available_av_equipment: {
    id: "shared.event_rules_form.available_av_equipment",
    defaultMessage: "Available AV equipment",
  },
  av_rules: {
    id: "shared.event_rules_form.av_rules",
    defaultMessage: "Rules for AV and music",
  },
  event_rules_header: {
    id: "shared.event_rules_form.event_rules_header",
    defaultMessage: "Event related rules and restrictions",
  },
  activities_not_permitted_header: {
    id: "listing.event_faq.section.activities_not_permitted",
    defaultMessage: "Events this space does not wish to host",
  },
});

const subtitles = defineMessages({
  kitchen_amenities: {
    id: "shared.event_faq.section.kitchen_amenities",
    defaultMessage: "Kitchen Amenities",
  },
  available_kitchen_setups: {
    id: "shared.event_faq.section.kitchen_setups",
    defaultMessage: "Available kitchen setups",
  },
  restrooms_and_facilities: {
    id: "shared.event_faq.section.restrooms_and_facilities",
    defaultMessage: "Restrooms and facilities",
  },
  tables: {
    id: "shared.event_faq.section.tables",
    defaultMessage: "Tables",
  },
  chairs: {
    id: "shared.event_faq.section.chairs",
    defaultMessage: "Chairs",
  },
  soft_seating: {
    id: "shared.event_faq.section.soft_seating",
    defaultMessage: "Soft Seating",
  },
});

const category_labels = defineMessages({
  food_and_beverage: {
    id: "shared.event_faq.section.food_beverage",
    defaultMessage: "Food and Beverage",
  },
  restrooms: {
    id: "shared.event_faq.section.restrooms",
    defaultMessage: "Restrooms",
  },
  alcohol: {
    id: "shared.event_faq.section.alcohol",
    defaultMessage: "Alcoholic Beverages",
  },
  furniture: {
    id: "shared.event_faq.section.furniture",
    defaultMessage: "Furniture",
  },
  activities: {
    id: "shared.event_faq.section.event_activities",
    defaultMessage: "Event Activities",
  },
  av_music: {
    id: "shared.event_faq.section.av_music",
    defaultMessage: "AV and Music",
  },
  rules: {
    id: "shared.event_faq.section.rules",
    defaultMessage: "Event Rules",
  },
});

const {
  serving_utensils_subheader,
  place_setting_tooltip,
  cups_tooltip,
  wine_glasses_tooltip,
  tables_tooltip,
  chairs_tooltip,
  soft_seating_tooltip,
  restroom_tooltip,
} = miscEventFaqDefinitions;

const {
  place_settings_subheader,
  other_food_rules_placeholder,
  other_food_prep_rules_placeholder,
  alcohol_consumption_placeholder,
  other_av_equipment_placeholder,
  other_activities_placeholder,
  other_prohibited_activities_placeholder,
  other_event_rules_placeholder,
} = miscEventFaqDefinitions;

const eventFaqDefinition = {
  food_and_beverage: {
    food_beverage_rules: defineMessages({
      outside_food_beverage_allowed: {
        id: "shared.food_and_beverage.event_faq_answers_const.outside_food_beverage_allowed",
        defaultMessage: "Outside food and non-alcoholic beverages allowed",
      },
      on_site_food_beverage: {
        id: "shared.food_and_beverage.event_faq_answers_const.on_site_food_beverage",
        defaultMessage:
          "Food and non-alcoholic beverages are available for purchase on-site only",
      },
      licensed_food_beverage: {
        id: "shared.food_and_beverage.event_faq_answers_const.licensed_food_beverage",
        defaultMessage:
          "Food and non-alcoholic beverages must be provided by a licensed vendor",
      },
      no_outside_food_beverage: {
        id: "shared.food_and_beverage.event_faq_answers_const.no_outside_food_beverage",
        defaultMessage:
          "No outside food, guests are allowed to bring specialty items (ie: cakes, dessert, etc)",
      },
      other_food_and_beverage_rules: {
        id: "shared.food_and_beverage.event_faq_answers_const.other_food_and_beverage_rules",
        defaultMessage: "Other",
        placeholder: other_food_rules_placeholder,
      },
    }),
    food_prep_rules: defineMessages({
      cooking_and_prep_allowed: {
        id: "shared.food_and_beverage.event_faq_answers_const.cooking_and_prep_allowed",
        defaultMessage: "Cooking and food preparation is allowed on-site",
      },
      only_food_prep: {
        id: "shared.food_and_beverage.event_faq_answers_const.only_food_prep",
        defaultMessage: "Only food preparation is allowed on-site",
      },
      no_cooking_allowed: {
        id: "shared.food_and_beverage.event_faq_answers_const.no_cooking_allowed",
        defaultMessage: "No cooking is allowed on-site",
      },
      other_food_prep_rules: {
        id: "shared.food_and_beverage.event_faq_answers_const.other_food_prep_rules",
        defaultMessage: "Other",
        placeholder: other_food_prep_rules_placeholder,
      },
    }),
    kitchen_setups_provided: defineMessages({
      full_kitchen: {
        id: "shared.food_and_beverage.full_kitchen",
        defaultMessage: "Full kitchen",
      },
      commercial_kitchen: {
        id: "shared.food_and_beverage.event_faq_const.commercial_kitchen",
        defaultMessage: "Commercial Kitchen",
      },
      kitchenette: {
        id: "shared.food_and_beverage.event_faq_const.kitchenette",
        defaultMessage: "Kitchenette",
      },
      prep_area: {
        id: "shared.food_and_beverage.event_faq_const.prep_area",
        defaultMessage: "Prep area",
      },
    }),
    kitchen_amenities_provided: defineMessages({
      place_settings: {
        id: "shared.food_and_beverage.event_faq_const.place_settings",
        defaultMessage: "Place settings",
        subheader: place_settings_subheader,
        tooltip: place_setting_tooltip,
      },
      serving_utensils: {
        id: "shared.food_and_beverage.event_faq_const.serving_utensils",
        defaultMessage: "Serving utensils",
        subheader: serving_utensils_subheader,
      },
      cups_glasses: {
        id: "shared.food_and_beverage.event_faq_const.cups_glasses",
        defaultMessage: "Cups",
        tooltip: cups_tooltip,
      },
      wine_glasses: {
        id: "shared.food_and_beverage.event_faq_const.wine_glasses",
        defaultMessage: "Wine glasses",
        tooltip: wine_glasses_tooltip,
      },
    }),
  },
  alcohol_beverages: {
    bring_alcohol: defineMessages({
      bring_alcohol_allowed: {
        id: "shared.alcohol_beverages.event_faq_answers_const.bring_alcohol_allowed",
        defaultMessage: "Guests can bring their own alcohol",
      },
      bring_alcohol_not_allowed: {
        id: "shared.alcohol_beverages.event_faq_answers_const.bring_alcohol_not_allowed",
        defaultMessage: "Guests are not allowed to bring their own alcohol",
      },
      no_alcohol_allowed: {
        id: "shared.alcohol_beverages.event_faq_answers_const.no_alcohol_allowed",
        defaultMessage: "Alcohol consumption is not allowed in the space",
      },
    }),
    bring_alcohol_rules: defineMessages({
      any_alcohol: {
        id: "shared.alcohol_beverages.event_faq_answers_const.any_alcohol",
        defaultMessage: "Any type of alcohol",
      },
      liquor_not_allowed: {
        id: "shared.alcohol_beverages.event_faq_answers_const.liquor_not_allowed",
        defaultMessage: "Beer, wine, and seltzers only. Liquor is not allowed.",
      },
      licensed_liquor: {
        id: "shared.alcohol_beverages.event_faq_answers_const.licensed_liquor",
        defaultMessage:
          "Beer, wine, and seltzers only. Liquor must be served by a licensed vendor.",
      },
    }),
    alcohol_consumption_options: defineMessages({
      alcohol_must_be_served_by_licensed_vendor: {
        id: "shared.alcohol_beverages.event_faq_const.alcohol_must_be_served_by_licensed_vendor",
        defaultMessage: "All alcohol must be served by a licensed vendor",
      },
      can_purchase_alcohol_at_full_service_bar: {
        id: "shared.alcohol_beverages.event_faq_const.can_purchase_alcohol_at_full_service_bar",
        defaultMessage:
          "Alcohol is available for purchase at our full service bar on-site",
      },
      can_purchase_beer_wine_at_bar: {
        id: "shared.alcohol_beverages.event_faq_const.can_purchase_beer_wine_at_bar",
        defaultMessage:
          "Beer and wine is available for purchase at our bar on-site",
      },
      other_alcohol_consumption_rules: {
        id: "shared.alcohol_beverages.event_faq_const.other_alcohol_consumption_rules",
        defaultMessage: "Other rules",
        placeholder: alcohol_consumption_placeholder,
      },
    }),
  },
  furniture: defineMessages({
    tables: {
      id: "shared.furniture_form.event_faq_const.tables",
      defaultMessage: "Dining tables, cocktail tables, etc",
      tooltip: tables_tooltip,
    },
    chairs: {
      id: "shared.furniture_form.event_faq_const.chairs",
      defaultMessage: "Dining chairs, stools, etc",
      tooltip: chairs_tooltip,
    },
    soft_seating: {
      id: "shared.furniture_form.event_faq_const.soft_seating",
      defaultMessage: "Sofas, lounge chairs, etc",
      tooltip: soft_seating_tooltip,
    },
  }),
  restroom: defineMessages({
    standard_restrooms: {
      id: "shared.restroom_form.how_many_restrooms",
      defaultMessage: "Restrooms on-site",
      tooltip: restroom_tooltip,
    },
    ada_restrooms: {
      id: "shared.restroom_form.has_ada_restrooms",
      defaultMessage: "ADA accessible restrooms",
    },
    nursing_rooms: {
      id: "shared.restroom_form.has_nursing_rooms",
      defaultMessage: "Nursing or parent room",
    },
  }),
  av_music: {
    provided_av_equipment: defineMessages({
      microphones: {
        id: "shared.av_music_form.event_faq_const.microphones",
        defaultMessage: "Microphones",
      },
      projector: {
        id: "shared.av_music_form.event_faq_const.projector",
        defaultMessage: "Projector",
      },
      speakers: {
        id: "shared.av_music_form.event_faq_const.speakers",
        defaultMessage: "Speakers",
      },
      television: {
        id: "shared.av_music_form.event_faq_const.television",
        defaultMessage: "Television",
      },
      misc_av_equipment: {
        id: "shared.av_music_form.event_faq_const.misc_av_equipment",
        defaultMessage: "Other AV equipment",
        placeholder: other_av_equipment_placeholder,
      },
    }),
    av_equipment_rules: defineMessages({
      is_dj_allowed: {
        id: "shared.av_music_form.event_faq_const.is_dj_allowed",
        defaultMessage: "DJs are allowed",
      },
      is_live_music_allowed: {
        id: "shared.av_music_form.event_faq_const.is_live_music_allowed",
        defaultMessage: "Live music is allowed",
      },
      is_amplified_music_allowed: {
        id: "shared.av_music_form.event_faq_const.is_amplified_music_allowed",
        defaultMessage: "Amplified music is allowed",
      },
      is_connected_amplified_music_allowed: {
        id: "shared.av_music_form.event_faq_const.is_connected_amplified_music_allowed",
        defaultMessage:
          "Guests may amplify music by connecting a personal device to speakers within the space",
      },
    }),
  },
  event_activities: {
    activities_provided: defineMessages({
      arcade_games: {
        id: "shared.event_activities.event_faq_const.arcade_games",
        defaultMessage: "Arcade Games",
      },
      darts: {
        id: "shared.event_activities.event_faq_const.darts",
        defaultMessage: "Darts",
      },
      karaoke: {
        id: "shared.event_activities.event_faq_const.karaoke",
        defaultMessage: "Karaoke",
      },
      ping_pong_table: {
        id: "shared.event_activities.event_faq_const.ping_pong_table",
        defaultMessage: "Ping pong table",
      },
      pool_table: {
        id: "shared.event_activities.event_faq_const.pool_table",
        defaultMessage: "Pool table",
      },
      shuffleboard: {
        id: "shared.event_activities.event_faq_const.shuffleboard",
        defaultMessage: "Shuffleboard",
      },
      misc_activities: {
        id: "shared.event_activities.event_faq_const.misc_activities",
        defaultMessage: "Other activities",
        placeholder: other_activities_placeholder,
      },
    }),
    prohibited_activities: defineMessages({
      is_21st_bday_prohibited: {
        id: "shared.event_activities.event_faq_const.is_21st_bday_prohibited",
        defaultMessage: "21st birthday party",
      },
      is_after_party_prohibited: {
        id: "shared.event_activities.event_faq_const.is_after_party_prohibited",
        defaultMessage: "After party",
      },
      is_album_release_party_prohibited: {
        id: "shared.event_activities.event_faq_const.is_album_release_party_prohibited",
        defaultMessage: "Album release party",
      },
      is_bachelor_party_prohibited: {
        id: "shared.event_activities.event_faq_const.is_bachelor_party_prohibited",
        defaultMessage: "Bachelorette / Bachelor party",
      },
      is_concert_prohibited: {
        id: "shared.event_activities.event_faq_const.is_concert_prohibited",
        defaultMessage: "Concert or live performance",
      },
      is_festival_holiday_party_prohibited: {
        id: "shared.event_activities.event_faq_const.is_festival_holiday_party_prohibited",
        defaultMessage:
          "Festival or holiday party (Halloween, Mardi Gras, New Years Eve)",
      },
      is_influencer_event_prohibited: {
        id: "shared.event_activities.event_faq_const.is_influencer_event_prohibited",
        defaultMessage: "Influencer event",
      },
      is_kids_party_prohibited: {
        id: "shared.event_activities.event_faq_const.is_kids_party_prohibited",
        defaultMessage: "Kids party",
      },
      is_party_prohibited: {
        id: "shared.event_activities.event_faq_const.is_party_prohibited",
        defaultMessage: "Party",
      },
      is_sports_viewing_party_prohibited: {
        id: "shared.event_activities.event_faq_const.is_sports_viewing_party_prohibited",
        defaultMessage: "Sporting event viewing party",
      },
      is_wedding_prohibited: {
        id: "shared.event_activities.event_faq_const.is_wedding_prohibited",
        defaultMessage: "Wedding",
      },
      other_prohibited_activity: {
        id: "shared.event_activities.event_faq_const.other_prohibited_activity",
        defaultMessage: "Other activities",
        placeholder: other_prohibited_activities_placeholder,
      },
    }),
  },
  event_rules: defineMessages({
    has_quiet_hours: {
      id: "shared.event_rules_form.event_faq_const.has_quiet_hours",
      defaultMessage:
        "No restrictions on noise during your space's operating hours",
    },
    loud_music_ends_by: {
      id: "shared.event_rules_form.event_faq_const.loud_music_ends_by",
      defaultMessage: "Any loud music or noise must end by",
    },
    is_glitter_allowed: {
      id: "shared.event_rules_form.event_faq_const.is_glitter_allowed",
      defaultMessage: "Confetti or glitter are allowed",
    },
    is_hired_security_required: {
      id: "shared.event_rules_form.event_faq_const.is_hired_security_required",
      defaultMessage: "Large events require hired security",
    },
    are_open_flames_allowed: {
      id: "shared.event_rules_form.event_faq_const.are_open_flames_allowed",
      defaultMessage: "Open flames are allowed",
    },
    are_pets_allowed: {
      id: "shared.event_rules_form.event_faq_const.are_pets_allowed",
      defaultMessage: "Pets are allowed",
    },
    is_smoking_allowed: {
      id: "shared.event_rules_form.event_faq_const.is_smoking_allowed",
      defaultMessage: "Smoking is allowed",
    },
    are_ticketed_events_allowed: {
      id: "shared.event_rules_form.event_faq_const.are_ticketed_events_allowed",
      defaultMessage: "Ticketed events are allowed",
    },
    other_event_rules: {
      id: "shared.event_rules_form.event_faq_const.other_event_rules",
      defaultMessage: "Other event rules",
      placeholder: other_event_rules_placeholder,
    },
    hours_adjusted_upon_request: {
      id: "shared.event_rules_form.event_faq_answers_const.hours_adjusted_upon_request",
      defaultMessage: "Yes, hours may be adjusted upon request",
    },
    has_no_flexible_hours: {
      id: "shared.event_rules_form.event_faq_answers_const.has_no_flexible_hours",
      defaultMessage: "No, hours are not flexible",
    },
  }),
} as IEventFaqDefinition;

const formattedMiscEventFaqDefinitions = {
  amenities_note: (
    <FormattedMessage
      id="shared.faq_form.amenities_note"
      defaultMessage="Amenities available for a fee must be added as an add-on item {addOnLink}"
      values={{
        addOnLink: (
          <a
            href="/hosting/add-ons"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 underline"
          >
            <FormattedMessage
              id="shared.event_activities_form.amenities_note_link"
              defaultMessage="here"
            />
          </a>
        ),
      }}
    />
  ),
  event_rules_info: (
    <FormattedMessage
      id="shared.faq_form.event_rules_info"
      defaultMessage="All events are subject to the {socialEventPolicyLink}. Event rules are considered part of your host rules which guests must agree to before booking your space."
      values={{
        socialEventPolicyLink: (
          <a
            href="/legal/terms/social-event-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
            style={{ color: "#886A2F" }}
          >
            <FormattedMessage
              id="shared.event_activities_form.social_event_policy"
              defaultMessage="Peerspace Social Event Policy"
            />
          </a>
        ),
      }}
    />
  ),
  loud_music_warning: (
    <FormattedMessage
      id="shared.faq_form.loud_music_warning"
      defaultMessage="* All social events at {residentialSpaces} spaces must start prior to 9:00 pm and end no later than 12:00 am (local time), inclusive of set-up and clean-up time. {socialEventPolicyLink}"
      values={{
        residentialSpaces: (
          <span className="heavier">
            <FormattedMessage
              id="shared.event_activities_form.loud_music_warning_residential"
              defaultMessage="residential"
            />
          </span>
        ),
        socialEventPolicyLink: (
          <a
            href="/legal/terms/social-event-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 underline"
          >
            <FormattedMessage
              id="shared.event_activities_form.loud_music_warning_learn_more"
              defaultMessage="Learn more"
            />
          </a>
        ),
      }}
    />
  ),
  residential_warning: (
    <FormattedMessage
      id="shared.faq_form.residential_warning"
      defaultMessage="* {residentialSpaces} are not allowed to hold ticketed events. {socialEventPolicyLink}"
      values={{
        residentialSpaces: (
          <Text typeface="body-1-m">
            <FormattedMessage
              id="shared.event_activities_form.residential_warning_heavy"
              defaultMessage="Residential Spaces"
            />
          </Text>
        ),
        socialEventPolicyLink: (
          <a
            href="/legal/terms/social-event-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="tw-text-gray-600 tw-underline"
          >
            <FormattedMessage
              id="shared.event_activities_form.residential_warning_learn_more"
              defaultMessage="Learn more"
            />
          </a>
        ),
      }}
    />
  ),
};

export {
  category_labels,
  eventFaqDefinition,
  formattedMiscEventFaqDefinitions,
  miscEventFaqDefinitions,
  subtitles,
};
